// extracted by mini-css-extract-plugin
export default {"TopBar":"GiocondaBrandTopBar_TopBar__kD9fQ"};